<template>
    <div id="app">
        <PageHeader/>
        <div class="main">
            <keep-alive v-if="$route.meta && $route.meta.keepAlive">
                <router-view/>
            </keep-alive>
            <router-view v-if="$route.meta && !$route.meta.keepAlive" />
        </div>
        <PageFooter />
    </div>
</template>
<script>

import PageHeader from "@/components/PageHeader.vue";
import PageFooter from "@/components/PageFooter.vue";

export default {

    data: function () {
        return {}
    },
    name: 'App',
    components: {
        PageHeader,PageFooter
    }
}
</script>
<style>
/*
 * 说明：
 * 1. z-index: 头部 100，底部 200，菜单 11*，提醒 9**，弹窗 8**
 */

/*-----------------[初始化]--------------*/
*, *:before, *:after { margin: 0; padding: 0; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; outline: none !important; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; -webkit-font-smoothing: antialiased; }
html, body, div, span, applet, object, iframe,h1, h2, h3, h4, h5, h6, p, blockquote, pre,a, abbr, acronym, address, big, cite, code,del, dfn, em, img, ins, kbd, q, s, samp,small, strike, strong, sub, sup, tt, var,b, u, i, center,dl, dt, dd, ol, ul, li,fieldset, form, label, legend,article, aside, canvas, details, embed,figure, figcaption, footer, header, hgroup,menu, nav, output, ruby, section, summary,time, mark, audio, video { margin: 0; padding: 0; border: 0; font-size: 100%; vertical-align: baseline;}
article, aside, details, figcaption, figure,footer, header, hgroup, menu, nav, section { display: block; }
ol, ul { list-style: none; }
blockquote, q { quotes: none; }
blockquote:before, blockquote:after, q:before, q:after { content: ""; }
table { border-collapse: collapse; border-spacing: 0; }
body { color: #000000; background: #fff; font: 14px/1.5 HarmonyOS_Sans_SC, sans-serif; outline: 0; }
a {color: #000000;text-decoration: none;}
a:hover { color: inherit; }
img {max-width: 100%;border: none;
    -webkit-transition: all .5s;
    -moz-transition: all .5s;
    -ms-transition: all .5s;
    -o-transition: all .5s;
    transition: all .5s;
}
em, i { font-style: normal; }
table { border-collapse: collapse; border-spacing: 0; }

input, textarea, select { font-size: 14px; color: #444; font-family: HarmonyOS_Sans_SC, sans-serif; outline: 0; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; -o-box-sizing: border-box; box-sizing: border-box; }
input[type="submit"], input[type="reset"], input[type="button"], select, button { -webkit-appearance: none; -moz-appearance: none; appearance: none; }
input[type="submit"], input[type="reset"], input[type="button"], button { cursor: pointer; }
.false:focus { border: 2px solid #ff1531; background: #fff; }

::-webkit-input-placeholder { color: #999; }
::-moz-placeholder { color: #999; }
::-ms-input-placeholder { color: #999; }
/* 去掉 IE10+ 密码框默认小眼睛、输入框 X */
::-ms-clear, ::-ms-reveal { display:none; }

.fix { *zoom: 1; }
.fix:after, .fix:before { display: block; content: ""; height: 0; clear: both; }
.c { clear: both; }

.col-l,.l { float: left; }
.col-r,.r { float: right; }

.ani { -ms-transition: .3s; -moz-transition: .3s; -webkit-transition: .3s; -o-transition: .3s; transition: .3s; }

/*无选中效果*/
.unselect { -ms-user-select: none; -moz-user-select: none; -khtml-user-select: none; -webkit-user-select: none; -o-user-select: none; user-select: none; }

/*布局*/
.wp { width: 90%; max-width: 1400px; margin: 0 auto; }
.h50 { height: 50px; clear: both; overflow: hidden; }
.h100 { height: 100px; clear: both; overflow: hidden; }




</style>
